import React from 'react';

// tslint:disable max-line-length
const CLetThemKnowPart1TranscriptDemo: React.FC = () => (
  <>
    <h5>Record a message for part 1</h5>
    <p>They say it’s the thought that counts. Sure, it’s a cliché but it’s true, right? I want to ask you to speak to this person. Let them hear your voice.  Talk to them as if you were leaving a voicemail.  It’s ok to be on your phone in here as long as you keep it low-key. You’re not disturbing anyone. You’ve got a moment to record a note about this object. What was the thought, and why does it count? Imagine them standing here after they’ve just found it – what do they need to hear? I can’t help you on this one – sorry – it’s better if it comes from you.   Take your time to think, and tap the button when you’re ready.</p>
  </>
);

export {
  CLetThemKnowPart1TranscriptDemo,
};
